import React from "react";
import { Link } from "react-router-dom";
import SocialMedia from "../components/SocialMedia";


const Home = () => {

    return (
        <>
            <section className="flex flex-col h-full p-4 bg-gradient-to-r from-teal-900 to-stone-800">
                {/* Social Media */}
                <SocialMedia title=""/>
                <article className="flex flex-col-reverse w-min-full h-5/6 justify-center items-center border-t border-gray-300 sm:flex-row">
                    {/* Bio */}
                    <div className="flex flex-col items-center justify-center m-2">
                        <h1 className="text-3xl text-yellow-500 sm:text-5xl">Charles Mbithi</h1>
                        <div className="flex text-white text-xl justify-center items-center sm:3xl" style={{textAlign: "center"}}>I'm a Software Engineer (Backend, Data Science, Machine Learning and 3D Modelling)</div>
                        <div className="flex flex-row">
                            <div className="std-button-underline mr-1">
                                <Link to="https://drive.google.com/file/d/1Aq8qcYqkGvg-F1HMhA6y4wOJPjF11f1h/view?usp=drive_link">My Resume</Link>
                            </div>
                            <div className="std-button-underline">
                                <Link to="/projects">My Projects</Link>
                            </div>
                        </div>
                    </div>
                </article>
            </section>
        </>
    )
}

export default Home;
